"use client"

import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import axios from "axios"
import { Link } from "react-router-dom"
import { ArrowLeft, Trophy } from "lucide-react"
import "../styles/RankingDetalhes.css"

const tipos = [
  { value: "vaqueiro", label: "Vaqueiro" },
  { value: "esteireiro", label: "Esteireiro" },
  { value: "cavaloPuxada", label: "Cavalo de Puxada" },
  { value: "cavaloEsteira", label: "Cavalo de Esteira" },
]

const RankingDetalhes = () => {
  const { id } = useParams()
  const [circuito, setCircuito] = useState(null)
  const [categoriaSelecionada, setCategoriaSelecionada] = useState("")
  const [tipoSelecionado, setTipoSelecionado] = useState("vaqueiro")
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchCircuito = async () => {
      try {
        setLoading(true)
        const res = await axios.get(`https://api.ticketdovaqueiro.com/api/circuitos/${id}`)
        setCircuito(res.data)
        setCategoriaSelecionada(res.data.categorias[0])
      } catch (err) {
        console.error("Erro ao carregar circuito:", err)
      } finally {
        setLoading(false)
      }
    }
    fetchCircuito()
  }, [id])

  const participantesFiltrados = circuito?.participantes
  ?.filter((p) => p.categoria === categoriaSelecionada && p.tipo === tipoSelecionado)
  ?.sort((a, b) => {
    if (b.pontos !== a.pontos) return b.pontos - a.pontos;
    return new Date(b.updatedAt || 0) - new Date(a.updatedAt || 0); // desempate
  });


  return (
    <div className="ranking-page">
      <div className="ranking-container">
        <Link to="/ranking" className="back-link">
          <ArrowLeft className="back-icon" />
          <span>Voltar para Circuitos</span>
        </Link>

        {loading ? (
          <div className="loading-container">
            <div className="loading-spinner"></div>
          </div>
        ) : (
          <>
            <div className="ranking-header">
              <div className="circuit-info">
                <Trophy className="trophy-icon" />
                <h1 className="circuit-title">{circuito?.nome}</h1>
              </div>

              <div className="filters-container">
                <div className="filter-group">
                  <label className="filter-label">Categoria</label>
                  <div className="select-wrapper">
                    <select
                      value={categoriaSelecionada}
                      onChange={(e) => setCategoriaSelecionada(e.target.value)}
                      className="filter-select"
                    >
                      {circuito?.categorias?.map((cat) => (
                        <option key={cat} value={cat}>
                          {cat}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="filter-group">
                  <label className="filter-label">Tipo</label>
                  <div className="select-wrapper">
                    <select
                      value={tipoSelecionado}
                      onChange={(e) => setTipoSelecionado(e.target.value)}
                      className="filter-select"
                    >
                      {tipos.map((t) => (
                        <option key={t.value} value={t.value}>
                          {t.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div className="table-container">
              <table className="ranking-table">
                <thead>
                  <tr>
                    <th>Posição</th>
                    <th>
                    <div className="th-name">Nome</div></th>
                    <th>Pontos</th>
                    <th>E</th>
                    <th>V</th>
                    <th>C</th>
                    <th>B</th>
                    <th>R</th>
                  </tr>
                </thead>
                <tbody>
                  {participantesFiltrados?.length > 0 ? (
                    participantesFiltrados.map((p, index) => (
                      <tr key={index}>
                        <td>
                          <div className="position-cell">{index + 1}º</div>
                        </td>
                        <td>
                          <div className="participant-name">{p.nome}</div>
                        </td>
                        <td>
                          <div className="points-value">{p.pontos}</div>
                        </td>
                        <td>
                          <div className="stat-value">{p.etapas}</div>
                        </td>
                        <td>
                          <div className="stat-value">{p.vaquejadas}</div>
                        </td>
                        <td>
                          <div className="stat-value">{p.classificacoes}</div>
                        </td>
                        <td>
                          <div className="stat-value">{p.bateuSenha}</div>
                        </td>
                        <td>
                          <div className="stat-value">{p.rachas}</div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={8} className="empty-message">
                        Nenhum participante encontrado para esta categoria e tipo.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>


            </div>
            <div className="ranking-legend">
                <h2>LEGENDA:</h2>
                <ul>
                  <li><strong>P</strong> = Total de <strong>PONTOS</strong> obtidos com os resultados de classificações</li>
                  <li><strong>E</strong> = Número de <strong>ETAPAS</strong> computadas até o momento</li>
                  <li><strong>V</strong> = Número de <strong>VAQUEJADAS</strong> que obteve classificação</li>
                  <li><strong>C</strong> = Número de <strong>CLASSIFICAÇÕES</strong> conquistadas</li>
                  <li><strong>B</strong> = Número de corridas em que <strong>BATEU</strong> a senha</li>
                  <li><strong>R</strong> = Quantidade de vaquejadas em que o competidor <strong>RACHOU</strong> a premiação</li>
                </ul>
              </div>
          </>
        )}
      </div>
    </div>
  )
}

export default RankingDetalhes
